// extracted by mini-css-extract-plugin
export default {"area":"area___lL_a2","opened":"opened___IGQy3","full_page":"full_page___Rhre1","close_btn":"close_btn___yQiQP","back_btn":"back_btn___kxdOI"};